var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.99981V14.9998H2V5.99981C2 4.67481 0 4.70606 0 5.99981V14.9998C0 16.1029 0.896875 16.9998 2 16.9998H14C15.1031 16.9998 16 16.1029 16 14.9998V5.99981C16 4.66544 14 4.68106 14 5.99981Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71467 11.7121L10.7241 9.67464C11.5709 8.75589 10.2834 7.57464 9.5178 8.27464L8.99905 8.79339L8.99592 1.98714C8.99592 0.652769 7.00843 0.684019 7.00843 1.98714L7.01155 8.79339L6.4928 8.27464C5.63968 7.53089 4.4553 8.83714 5.28655 9.67464L7.29593 11.7121C7.4803 11.9028 8.08655 12.2496 8.71467 11.7121Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.449ca06737ff483380250f3dbcbd6aad.svg";
export { ForwardRef as ReactComponent };